import { createApp } from 'vue'
import App from './App.vue'
import router from './router'
import store from './store'
import axios from 'axios'
import 'bulma/css/bulma.css';
import 'bulma-quickview/dist/css/bulma-quickview.min.css';
import bulmaQuickview from 'bulma-quickview/src/js';
import './fontawesome.js';
import { FontAwesomeIcon } from './fontawesome';
// import './assets/main.scss'

axios.defaults.baseURL = process.env.VUE_APP_API_BASE_URL;
axios.defaults.headers.common['Authorization'] = `Bearer ${localStorage.getItem('token')}`; // or however your token is stored

const app = createApp(App);

app.use(store);
app.component('font-awesome-icon', FontAwesomeIcon);
app.use(router, axios);

// Initialize Bulma Quickview
document.addEventListener('DOMContentLoaded', () => {
  bulmaQuickview.attach();
});

app.mount('#app');
